import React from "react";
import styled from "styled-components";
import { main, dark, light } from "../../style/themes";

const getColor = (props, colorName) => {
  let theme = main;
  if (props.name === "dark") {
    theme = dark;
  } else if (props.name === "light") {
    theme = light;
  }
  return theme.colors[colorName];
};

const boxSize = "1rem";

const StyledButton = styled.button`
  border: 2px solid ${(props) => getColor(props, "second")};
  background: ${(props) => getColor(props, "main")};
  color: ${(props) => getColor(props, "second")};
  width: ${boxSize};
  height: ${boxSize};
  margin: 0 0.25rem;
  &.focus,
  &:focus {
    outline: 0;
  }
`;

const ThemeButton = (props) => {
  const disabled = props.themeName === props.name;

  return (
    <StyledButton
      onClick={() => props.handleClick(props.name)}
      disabled={disabled}
      name={props.name}
    />
  );
};

export default ThemeButton;
